import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, unref as _unref } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  key: 1,
  style: {
    "color": "#5186ef"
  }
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  key: 1,
  style: {
    "color": "#5186ef"
  }
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 1,
  style: {
    "color": "#5186ef",
    "display": "inline"
  }
};
const _hoisted_7 = {
  class: "computeSelect"
};
const _hoisted_8 = {
  class: "right"
};
import { computed, getCurrentInstance, onBeforeMount, onMounted, reactive, ref, watch } from "vue";
import apis from "@/api";
import { ElMessage, ElMessageBox } from "element-plus";
import AccessoryUpload from '@/components/MoreUpload';
import RecordUpload from "../components/Upload.vue";
import { USERINFO } from "@/store/mutation-types";
import { updateContractDetail } from "../../../../api/modules/advert";
import common from "@/views/Home/MyNeeds/composables/common";
export default {
  __name: 'ContractSettlementEdit',
  props: {
    title: {
      type: String,
      default: '结算单明细',
      required: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    detail: {
      type: Object
    },
    isAudit: {
      type: Boolean,
      default: false
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    actionName: {
      type: String,
      default: 'handleView'
    },
    contract: {
      type: Object
    }
  },
  emits: ['update:visible', 'submit'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const {
      proxy
    } = getCurrentInstance();
    const headerStyle = ref({
      background: '#FAFAFA'
    });
    const deleteBynV = computed(() => {
      if (props.actionName === 'handleView') {
        return true;
      }
      return false;
    });
    const emits = __emit;
    const props = __props;
    const data = reactive({
      tableData: [],
      pagination: {
        totalSize: 0,
        pageSize: 200,
        pageNo: 1
      },
      audit: {
        examineState: 0,
        examineOpinion: null,
        totalIncludingTax: 0
      },
      recordTableData: [],
      recordPagination: {
        totalSize: 0,
        pageSize: 10,
        pageNo: 1
      },
      activeNames: ['record'],
      activeNames2: ['accessory'],
      uploadTitle: "上传扫描件",
      fileInfos: [],
      uploadFiles: [],
      accessoryTableData: [],
      accessoryPagination: {
        totalSize: 0,
        pageSize: 200,
        pageNo: 1
      },
      tabClickIndex: '',
      tabClickLabel: '',
      isShowBtn: false,
      info: ''
    });
    const pricingUnitItem = [{
      value: 1,
      label: '/'
    }, {
      value: 2,
      label: '天'
    }, {
      value: 3,
      label: '周'
    }, {
      value: 4,
      label: '月'
    }, {
      value: 5,
      label: '季度'
    }, {
      value: 6,
      label: '年'
    }];
    const elLoading = ref(false);
    const recordUpload = ref();
    const confirmVisible = ref(false);
    const confirmSubmit = ref(false);
    const contractAreaAdmins = ref([]);
    const confirmValue = ref(0);
    const showHandleAudit = ref(false);
    const showRecordTag = ref(true);
    const isRecordTag = ref(false);
    const uploadVisible = ref(false);
    const computeMode = ref(1);
    const statementArea = ref('');
    const contractAreas = ref([]);
    const computedMode = [{
      value: 1,
      label: '含税总价 = 不含税总价 * 税率'
    }, {
      value: 2,
      label: '含税总价 = 含税单价 * 数量'
    }];
    const setTotalIncludingTax = row => {
      // 默认 含税总价 = 不含税总价 * 税率
      if (computeMode.value === 1) {
        row.totalIncludingTax = Number((row.totalExcludingTax * (1 + row.vatRate / 100)).toFixed(6));
        return;
      } else if (computeMode.value === 2) {
        // 含税总价 = 含税单价 * 数量
        row.totalIncludingTax = Number((row.settlementQuantity * row.unitPriceIncludingTax * row.pricingQuantity).toFixed(6));
      }
    };
    const computedAll = () => {
      for (let item of data.tableData) {
        setTotalIncludingTax(item);
      }
    };
    const close = () => {
      showHandleAudit.value = false;
      data.audit = {
        examineState: 0,
        examineOpinion: null,
        totalIncludingTax: 0
      };
      emits('update:visible', false);
    };
    const tabClick = (row, column) => {
      switch (column.label) {
        case '增值税率':
          data.tabClickIndex = row.index;
          data.tabClickLabel = column.label;
          break;
        case '结算数量':
          data.tabClickIndex = row.index;
          data.tabClickLabel = column.label;
          break;
        case '时长':
          data.tabClickIndex = row.index;
          data.tabClickLabel = '计价维度';
        default:
          return;
      }
    };
    const selectAllUnit = () => {
      for (let item of data.tableData) {
        item.pricingUnit = data.allUnit;
        selectUnit(item);
      }
    };
    const handleDeleteAccessory = row => {
      //将上传附件数据在临时展示中删除
      ElMessageBox.confirm('确定要删除该附件吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        data.uploadFiles = data.uploadFiles.filter(f => f.fileId != row.fileId);
        data.accessoryTableData = data.uploadFiles;
      });
    };
    const selectUnit = row => {
      if (row.pricingUnit === 1) {
        row.pricingQuantity = 1;
      }
      row.totalExcludingTax = (row.settlementQuantity * row.unitPriceExcludingTax * row.pricingQuantity).toFixed(6);
      row.totalExcludingTax = Number(row.totalExcludingTax);
      setTotalIncludingTax(row);
    };
    const inputBlur = rowData => {
      data.tabClickIndex = null;
      data.tabClickLabel = '';
      if (Number.isNaN(parseFloat(rowData.settlementQuantity))) {
        data.isShowBtn = true;
        ElMessage.error('数量请输入正整数');
        return;
      } else {
        const re = /^[0-9]\d*(\.\d{1,6})?$/;
        const rsCheck = re.test(rowData.settlementQuantity);
        if (!rsCheck) {
          data.isShowBtn = true;
          ElMessage.error('数量请输入正整数');
          return;
        }
      }
      data.isShowBtn = false;
      rowData.totalExcludingTax = (rowData.settlementQuantity * rowData.unitPriceExcludingTax * rowData.pricingQuantity).toFixed(6);
      rowData.totalExcludingTax = Number(rowData.totalExcludingTax);
      setTotalIncludingTax(rowData);
    };

    //结算单信息分页改变
    const handleSizeChange = val => {
      data.pagination.pageSize = val;
      loadData();
    };
    const handleCurrentChange = val => {
      data.pagination.pageNo = val;
      loadData();
    };
    //归档信息分页改变
    const handleSizeChangeRecord = val => {
      data.recordPagination.pageSize = val;
      loadDataDetailedSettlementTag(props.detail);
    };
    const handleCurrentChangeRecord = val => {
      data.recordPagination.pageNo = val;
      loadDataDetailedSettlementTag(props.detail);
    };

    //附件信息分页改变
    const handleSizeChangeAccessory = val => {
      data.accessoryPagination.pageSize = val;
      loadDataDetailedSettlementAccessoryTag(props.detail);
    };
    const handleCurrentChangeAccessory = val => {
      data.accessoryPagination.pageNo = val;
      loadDataDetailedSettlementAccessoryTag(props.detail);
    };
    const handlerUploadSuccess = files => {
      uploadVisible.value = false;
      if (files && files.length > 0) {
        let uploadFiles = [];
        files.forEach(f => {
          const name = f.fileName.substring(0, f.fileName.lastIndexOf("."));
          const item = {
            fileId: f.id,
            name: name,
            fileName: f.fileName,
            fileUrl: f.relativeUrl,
            upTime: f.uploadTime,
            upUser: f.operator,
            fileType: f.fileType
            //id结算单ID
          };
          uploadFiles.push(item);
        });
        data.uploadFiles = data.uploadFiles.concat(uploadFiles);
        //将文件信息赋值给附件表格作为临时展示，提交审核后方可保存
        data.accessoryTableData = data.uploadFiles;
      } else {
        ElMessage.error('请先上传附件!');
      }
    };
    const loadData = () => {
      const param = {
        detailedId: props.detail.id,
        ...data.pagination
      };
      elLoading.value = true;
      apis.getDetailedSettlementList(param).then(res => {
        if (res.success) {
          const {
            records,
            size,
            total,
            current
          } = res.data;
          data.tableData = records;
          data.pagination = {
            totalSize: total,
            pageSize: size,
            pageNo: current
          };
          records.forEach(item => {
            data.audit.totalIncludingTax = data.audit.totalIncludingTax + item.totalIncludingTax;
          });
        } else {
          ElMessage.error(res.msg);
        }
      }).catch(err => {
        ElMessage.error(err);
      }).finally(() => {
        elLoading.value = false;
      });
    };
    const handleUpload = () => {
      uploadVisible.value = true;
    };
    const pricingInputBlur = row => {
      data.tabClickIndex = null;
      data.tabClickLabel = '';
      if (!row.pricingQuantity) {
        data.isShowBtn = true;
        ElMessage.error('时长请输入正数');
        return;
      }
      if (Number.isNaN(parseFloat(row.pricingQuantity))) {
        data.isShowBtn = true;
        ElMessage.error('时长请输入正数');
        return;
      } else if (Number(row.pricingQuantity) === 0) {
        data.isShowBtn = true;
        ElMessage.error('时长请输入正数');
        return;
      } else {
        // 时长为正整数或正六位浮点数
        const re = /^[0-9]\d*(\.\d{1,6})?$/;
        const rsCheck = re.test(row.pricingQuantity);
        if (!rsCheck) {
          data.isShowBtn = true;
          ElMessage.error('时长请输入正数');
          return;
        }
      }
      if (row.pricingQuantity > 1 && row.pricingUnit === 1) {
        row.pricingUnit = 2;
      }
      data.isShowBtn = false;
      row.totalExcludingTax = (row.settlementQuantity * row.unitPriceExcludingTax * row.pricingQuantity).toFixed(6);
      row.totalExcludingTax = Number(row.totalExcludingTax);
      setTotalIncludingTax(row);
    };
    const taxRateInputBlur = rowData => {
      data.tabClickIndex = null;
      data.tabClickLabel = '';
      if (!rowData.vatRate) {
        data.isShowBtn = true;
        ElMessage.error('税率请输入正整数');
      }
      if (!Number(rowData.vatRate)) {
        data.isShowBtn = true;
        ElMessage.error('税率请输入正整数');
        return;
      } else if (Number(rowData.vatRate) === 0) {
        data.isShowBtn = true;
        ElMessage.error('税率请输入正整数');
        return;
      } else {
        const re = /^[0-9]\d*(\.\d{1,6})?$/;
        const rsCheck = re.test(rowData.vatRate);
        if (!rsCheck) {
          data.isShowBtn = true;
          ElMessage.error('税率请输入正整数');
          return;
        }
      }
      data.isShowBtn = false;
      rowData.unitPriceIncludingTax = rowData.unitPriceExcludingTax + rowData.unitPriceExcludingTax * Number(rowData.vatRate) / 100;
      rowData.unitPriceIncludingTax = Number(rowData.unitPriceIncludingTax.toFixed(6));
      setTotalIncludingTax(rowData);
    };
    const DetailedSettlementList = row => {
      const param = {
        detailedId: row.id,
        pageNo: data.pagination.pageNo,
        pageSize: data.pagination.pageSize
      };
      apis.getDetailedSettlementList(param).then(res => {
        if (res.success) {
          const {
            records,
            size,
            total,
            current
          } = res.data;
          data.tableData = records;
          data.pagination = {
            totalSize: total,
            pageSize: size,
            pageNo: current
          };
          records.forEach(item => {
            data.audit.totalIncludingTax = data.audit.totalIncludingTax + item.totalIncludingTax;
          });
        } else {
          ElMessage.error(res.msg);
        }
      }).catch(err => {
        ElMessage.error(err);
      }).finally(() => {
        elLoading.value = false;
      });
    };
    onMounted(() => {
      initArea();
    });
    const downFile = row => {
      window.open(row.fileUrl);
    };
    const handlerFileChange = files => {
      data.uploadFiles = files;
    };
    const loadDataDetailedSettlementTag = row => {
      const param = {
        // ...data.recordPagination,
        total: data.recordPagination.totalSize,
        size: data.recordPagination.pageSize,
        current: data.recordPagination.pageNo,
        detailSettlementId: row.id
      };
      apis.queryDetailedSettlementTagByPage(param).then(res => {
        if (res.success) {
          const {
            records,
            size,
            total,
            current
          } = res.data;
          data.recordTableData = records;
          data.recordPagination = {
            totalSize: total,
            pageSize: size,
            pageNo: current
          };
        } else {
          ElMessage.error(res.msg);
        }
      }).catch(err => {
        ElMessage.error(err);
      }).finally(() => {});
    };
    const loadDataDetailedSettlementAccessoryTag = row => {
      const param = {
        // ...data.accessoryPagination,
        total: data.accessoryPagination.totalSize,
        size: data.accessoryPagination.pageSize,
        current: data.accessoryPagination.pageNo,
        detailSettlementId: row.id,
        serviceType: '1'
      };
      apis.queryDetailedSettlementAccessoryTagByPage(param).then(res => {
        if (res.success) {
          const {
            records,
            size,
            total,
            current
          } = res.data;
          data.accessoryTableData = records;
          data.uploadFiles = records;
          data.accessoryPagination = {
            totalSize: total,
            pageSize: size,
            pageNo: current
          };
        } else {
          ElMessage.error(res.msg);
        }
      }).catch(err => {
        ElMessage.error(err);
      }).finally(() => {});
    };
    const getSumAmount = () => {
      const sums = [];
      sums[0] = '合计';
      let sumExcluding = 0;
      let sumtIncluding = 0;
      data.tableData.forEach(column => {
        sumExcluding = sumExcluding + column.totalExcludingTax;
        sumtIncluding = sumtIncluding + column.totalIncludingTax;
      });
      sums[11] = Number(sumExcluding.toFixed(6));
      sums[12] = Number(sumtIncluding.toFixed(6));
      return sums;
    };
    const getRateAfter = () => {
      data.info.rateAfter = (data.info.theorySettlementAmount * data.info.settlementRate * 0.01).toFixed(2);
      data.info.currentSettlementAmount = data.info.rateAfter;
      confirmValue.value = data.info.currentSettlementAmount;
      checkConfirm();
    };
    const handleSaveSettlement = () => {
      let sumtIncluding = 0;
      data.tableData.forEach(column => {
        sumtIncluding = sumtIncluding + column.totalIncludingTax * 100;
      });
      data.info = props.detail;
      data.info.theorySettlementAmount = Number((sumtIncluding / 100).toFixed(6));
      getRateAfter();
      data.info.examineDate = '';
      data.uploadFiles.forEach(f => {
        f.detailSettlementId = data.info.id;
        f.serviceType = '1';
      });
      confirmValue.value = data.info.currentSettlementAmount;
      if (props.detail.statementArea != null && props.detail.statementArea !== '') {
        statementArea.value = props.detail.statementArea;
      } else {
        statementArea.value = props.contract.areaCode;
      }
      confirmVisible.value = true;
      confirmSubmit.value = false;
    };
    const confirmSubmitForm = () => {
      if (data.info.settlementRate < 100 && (!data.info.settlementRateDesc || !data.info.settlementRateDesc.trim())) {
        ElMessage.error('请输入结算比例说明');
        return;
      }
      if (!statementArea.value) {
        ElMessage.error('请选择结算地区');
        return;
      }
      if (data.info.settlementPersonnel == null || data.info.settlementPersonnel === '') {
        ElMessage.error('请选择结算审核人');
        return;
      }
      confirmSubmit.value = true;
      confirmVisible.value = false;
      data.info.currentSettlementAmount = Number(confirmValue.value);
      data.info.statementArea = statementArea.value;
      apis.updateContractDetail({
        detailedInfo: data.info,
        fileList: data.uploadFiles,
        detailList: data.tableData
      }).then(res => {
        if (res.success) {
          emits("submit");
          emits('update:visible', false);
          ElMessage.success('提交成功');
        } else {
          ElMessage.error(res.msg);
        }
      }).catch(err => {
        ElMessage.error(err);
      });
    };
    const checkConfirm = () => {
      confirmSubmit.value = true;
      if (!Number(confirmValue.value)) {
        ElMessage.error('请输入有效两位小数数字!');
        return;
      }
      const re = /^[0-9]\d*(\.\d{1,2})?$/;
      const rsCheck = re.test(confirmValue.value.toString());
      if (!rsCheck) {
        data.isShowBtn = true;
        ElMessage.error('请输入有效两位小数数字!');
        return;
      }
      let mistake = Math.abs(Number(confirmValue.value) - Number(data.info.rateAfter));
      mistake = Number(mistake.toFixed(6));
      if (mistake > Number('0.03')) {
        ElMessage.error('差额修改不能大于0.03!');
        return;
      }
      confirmSubmit.value = false;
    };
    const initArea = () => {
      statementArea.value = props.contract.areaCode;
      const areas = props.contract.areaCodeList.split(',');
      for (const area of areas) {
        contractAreas.value.push({
          code: area,
          name: common().getAreaByCode(area)
        });
      }
    };
    watch(() => statementArea.value, newValue => {
      if (!newValue) {
        contractAreaAdmins.value = [];
        return;
      }
      apis.getRolesUserList('contract_admin_' + newValue).then(res => {
        if (res.success) {
          contractAreaAdmins.value = Array.isArray(res.data) ? res.data : [];
        } else {
          ElMessage.error(res.msg || '合同管理员查询失败');
        }
      }).catch(() => {
        ElMessage.error('合同管理员查询失败');
      });
    });
    watch(() => props.actionName, (newvalue, oldvalue) => {
      if (newvalue === 'handleAudit') {
        showRecordTag.value = false;
      } else {
        showRecordTag.value = true;
      }
      if (newvalue === 'handleRecord') {
        isRecordTag.value = true;
      } else {
        isRecordTag.value = false;
      }
    }, {
      deep: false,
      immediate: true
    });
    __expose({
      DetailedSettlementList,
      loadDataDetailedSettlementTag,
      loadDataDetailedSettlementAccessoryTag
    });
    return (_ctx, _cache) => {
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_collapse_item = _resolveComponent("el-collapse-item");
      const _component_el_collapse = _resolveComponent("el-collapse");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_input_number = _resolveComponent("el-input-number");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_el_dialog, {
        title: __props.title,
        "model-value": __props.visible,
        onClose: close,
        "close-on-press-escape": false,
        "destroy-on-close": true,
        width: "100%",
        fullscreen: ""
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: close
        }, {
          default: _withCtx(() => [...(_cache[19] || (_cache[19] = [_createTextVNode("取消", -1)]))]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleSaveSettlement,
          disabled: data.isShowBtn
        }, {
          default: _withCtx(() => [...(_cache[20] || (_cache[20] = [_createTextVNode("提交审核", -1)]))]),
          _: 1
        }, 8, ["disabled"])]),
        default: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("div", null, [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: data.tableData,
          style: {
            "width": "100%"
          },
          "header-cell-style": headerStyle.value,
          border: "",
          "show-summary": "",
          "summary-method": getSumAmount,
          onCellClick: tabClick
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            fixed: "",
            prop: "ranking",
            label: "序号"
          }), _createVNode(_component_el_table_column, {
            fixed: "",
            prop: "productCategory",
            label: "产品大类/类别",
            "min-width": "100"
          }), _createVNode(_component_el_table_column, {
            fixed: "",
            prop: "projectContent",
            label: "产品小类/项目内容",
            "min-width": "200"
          }), _createVNode(_component_el_table_column, {
            fixed: "",
            prop: "standardSpecifications",
            label: "标准规格",
            "min-width": "200"
          }), _createVNode(_component_el_table_column, {
            fixed: "",
            prop: "unit",
            label: "报价单位"
          }), _createVNode(_component_el_table_column, {
            fixed: "",
            prop: "unitPriceExcludingTax",
            label: "不含税单价/元"
          }), _createVNode(_component_el_table_column, {
            fixed: "",
            prop: "vatRate",
            label: "增值税率"
          }, {
            default: _withCtx(scope => [scope.row.index === data.tabClickIndex && data.tabClickLabel === '增值税率' ? (_openBlock(), _createElementBlock("span", _hoisted_1, [_createVNode(_component_el_input, {
              modelValue: scope.row.vatRate,
              "onUpdate:modelValue": $event => scope.row.vatRate = $event,
              maxlength: "300",
              placeholder: "请输入增值税率",
              size: "mini",
              onBlur: $event => taxRateInputBlur(scope.row)
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])])) : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(scope.row.vatRate) + "%", 1))]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            fixed: "",
            prop: "unitPriceIncludingTax",
            label: "含税单价/元"
          }), _createVNode(_component_el_table_column, {
            fixed: "",
            prop: "settlementQuantity",
            label: "结算数量",
            "min-width": "70"
          }, {
            default: _withCtx(scope => [scope.row.index === data.tabClickIndex && data.tabClickLabel === '结算数量' ? (_openBlock(), _createElementBlock("span", _hoisted_3, [_createVNode(_component_el_input, {
              modelValue: scope.row.settlementQuantity,
              "onUpdate:modelValue": $event => scope.row.settlementQuantity = $event,
              maxlength: "300",
              placeholder: "请输入结算数量",
              size: "small",
              onBlur: $event => inputBlur(scope.row)
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])])) : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(scope.row.settlementQuantity), 1))]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            fixed: "",
            label: "计价维度"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              fixed: "",
              prop: "pricingQuantity",
              label: "时长"
            }, {
              default: _withCtx(scope => [scope.row.index === data.tabClickIndex && data.tabClickLabel === '计价维度' ? (_openBlock(), _createElementBlock("span", _hoisted_5, [_createVNode(_component_el_input, {
                modelValue: scope.row.pricingQuantity,
                "onUpdate:modelValue": $event => scope.row.pricingQuantity = $event,
                maxlength: "300",
                placeholder: "请输入时长",
                onBlur: $event => pricingInputBlur(scope.row),
                size: "small"
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])])) : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(scope.row.pricingQuantity), 1))]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              fixed: "",
              label: "单位",
              "min-width": "130"
            }, {
              header: _withCtx(() => [_cache[15] || (_cache[15] = _createElementVNode("span", null, " 单位 ", -1)), _createElementVNode("span", null, [_createVNode(_component_el_select, {
                modelValue: data.allUnit,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => data.allUnit = $event),
                placeholder: "",
                style: {
                  "width": "70px"
                },
                onChange: selectAllUnit
              }, {
                default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(pricingUnitItem, item => {
                  return _createVNode(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]);
                }), 64))]),
                _: 1
              }, 8, ["modelValue"])])]),
              default: _withCtx(scope => [_createVNode(_component_el_select, {
                modelValue: scope.row.pricingUnit,
                "onUpdate:modelValue": $event => scope.row.pricingUnit = $event,
                placeholder: "",
                size: "small",
                onChange: $event => selectUnit(scope.row)
              }, {
                default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(pricingUnitItem, item => {
                  return _createVNode(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]);
                }), 64))]),
                _: 1
              }, 8, ["modelValue", "onUpdate:modelValue", "onChange"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            fixed: "",
            prop: "totalExcludingTax",
            label: "不含税合计/元",
            "min-width": "120"
          }), _createVNode(_component_el_table_column, {
            fixed: "",
            prop: "totalIncludingTax",
            label: "含税合计/元",
            "min-width": "130"
          }, {
            header: _withCtx(() => [_cache[16] || (_cache[16] = _createElementVNode("span", null, " 含税合计/元 ", -1)), _createElementVNode("span", _hoisted_7, [_createVNode(_component_el_select, {
              modelValue: computeMode.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => computeMode.value = $event),
              placeholder: "",
              onChange: computedAll
            }, {
              default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(computedMode, item => {
                return _createVNode(_component_el_option, {
                  key: item.value,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]);
              }), 64))]),
              _: 1
            }, 8, ["modelValue"])])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data", "header-cell-style"])), [[_directive_loading, elLoading.value]])]), _createElementVNode("div", null, [_createVNode(_component_el_pagination, {
          onSizeChange: handleSizeChange,
          onCurrentChange: handleCurrentChange,
          "page-sizes": [200],
          "page-size": data.pagination.pageSize,
          total: data.pagination.totalSize,
          currentPage: data.pagination.pageNo,
          "onUpdate:currentPage": _cache[2] || (_cache[2] = $event => data.pagination.pageNo = $event),
          layout: "total, prev, pager, next, sizes, jumper"
        }, null, 8, ["page-size", "total", "currentPage"])]), _createVNode(_component_el_collapse, {
          modelValue: data.activeNames2,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => data.activeNames2 = $event)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_collapse_item, {
            title: "结算单附件",
            name: "accessory"
          }, {
            default: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("div", null, [_createVNode(_component_el_row, null, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createVNode(_component_el_button, {
                type: "primary",
                onClick: _withModifiers(handleUpload, ["stop"])
              }, {
                default: _withCtx(() => [...(_cache[17] || (_cache[17] = [_createTextVNode("上传附件", -1)]))]),
                _: 1
              })])]),
              _: 1
            }), _createVNode(_component_el_table, {
              data: data.accessoryTableData,
              style: {
                "width": "100%"
              },
              "header-cell-style": headerStyle.value
            }, {
              default: _withCtx(() => [_createVNode(_component_el_table_column, {
                prop: "name",
                label: "文件名"
              }), _createVNode(_component_el_table_column, {
                prop: "upTime",
                label: "上传时间"
              }), _createVNode(_component_el_table_column, {
                prop: "upUser",
                label: "上传人"
              }), _createVNode(_component_el_table_column, {
                label: "操作",
                width: "150"
              }, {
                default: _withCtx(scope => [_createVNode(_component_el_button, {
                  link: "",
                  size: "small",
                  type: "primary",
                  onClick: $event => handleDeleteAccessory(scope.row)
                }, {
                  default: _withCtx(() => [...(_cache[18] || (_cache[18] = [_createTextVNode("删除", -1)]))]),
                  _: 1
                }, 8, ["onClick"])]),
                _: 1
              })]),
              _: 1
            }, 8, ["data", "header-cell-style"])]), _createElementVNode("div", null, [_createVNode(_component_el_pagination, {
              onSizeChange: handleSizeChangeAccessory,
              onCurrentChange: handleCurrentChangeAccessory,
              "page-sizes": [200, 500],
              "page-size": data.accessoryPagination.pageSize,
              total: data.accessoryPagination.totalSize,
              currentPage: data.accessoryPagination.pageNo,
              "onUpdate:currentPage": _cache[3] || (_cache[3] = $event => data.accessoryPagination.pageNo = $event),
              layout: "total,prev, pager, next, sizes, jumper"
            }, null, 8, ["page-size", "total", "currentPage"])])])]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])]), _createVNode(_unref(AccessoryUpload), {
          visible: uploadVisible.value,
          "onUpdate:visible": _cache[5] || (_cache[5] = $event => uploadVisible.value = $event),
          multiple: true,
          onUploadSuccess: handlerUploadSuccess
        }, null, 8, ["visible"]), _createVNode(_component_el_dialog, {
          title: "确认结算金额",
          "model-value": confirmVisible.value,
          width: "40%",
          onClose: _cache[14] || (_cache[14] = $event => confirmVisible.value = false),
          "close-on-press-escape": false
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form, {
            "label-position": "left"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "本次结算金额（理论）"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                placeholder: "本次结算金额",
                modelValue: data.info.theorySettlementAmount,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => data.info.theorySettlementAmount = $event),
                disabled: ""
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "结算比例（%）：",
              prop: "settlementRate"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input_number, {
                modelValue: data.info.settlementRate,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => data.info.settlementRate = $event),
                onChange: getRateAfter,
                precision: 2,
                step: 1,
                min: 0,
                max: 100
              }, {
                suffix: _withCtx(() => [...(_cache[21] || (_cache[21] = [_createElementVNode("span", null, "%", -1)]))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            }), data.info.settlementRate < 100 ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: "结算比例说明：",
              prop: "settlementRateDesc"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                placeholder: "根据合同考核条款，考核分XX分，结算比例X%",
                modelValue: data.info.settlementRateDesc,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => data.info.settlementRateDesc = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
              label: "结算金额（折算后）："
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: data.info.rateAfter,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => data.info.rateAfter = $event),
                disabled: ""
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "结算金额（调整后）"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                placeholder: "结算金额调整",
                modelValue: confirmValue.value,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => confirmValue.value = $event),
                onBlur: checkConfirm
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "结算地区"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: statementArea.value,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => statementArea.value = $event),
                onChange: _cache[12] || (_cache[12] = $event => data.info.settlementPersonnel = null),
                placeholder: "选择结算地区"
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contractAreas.value, item => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: item.code,
                    label: item.name,
                    value: item.code
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "结算单审核人：",
              prop: "settlementPersonnel"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: data.info.settlementPersonnel,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => data.info.settlementPersonnel = $event),
                placeholder: "选择审核人"
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contractAreaAdmins.value, item => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: item.userId,
                    label: item.name,
                    value: item.userId
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "primary",
            onClick: confirmSubmitForm,
            disabled: confirmSubmit.value
          }, {
            default: _withCtx(() => [...(_cache[22] || (_cache[22] = [_createTextVNode("提交审核", -1)]))]),
            _: 1
          }, 8, ["disabled"])]),
          _: 1
        }, 8, ["model-value"])]),
        _: 1
      }, 8, ["title", "model-value"]);
    };
  }
};